// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"71d430a7","455":"28242295"}[chunkId] + ".chunk.js";
};